module.exports = __webpack_public_path__ + "static/media/closeicon.4fca35be.svg";